import { createContext, useContext } from 'react';

export type EntradaSaida = 'entradas' | 'saidas';

export interface SimplesNacionalPermissoes {
  podeUpload: boolean;
  podeExportar: boolean;
  podeReprocessar: boolean;
}

export interface SimplesNacionalContextData {
  // Empresa selecionada no header
  cnpjContribuinte: string | null;

  // Período selecionado no header
  dataInicio: string | null;
  dataFim: string | null;

  // Entrada/Saída compartilhada entre telas do módulo
  entradaSaida: EntradaSaida;
  setEntradaSaida: (valor: EntradaSaida) => void;

  // Permissões do usuário dentro do módulo
  permissoes: SimplesNacionalPermissoes;

  // Reload global — incrementar força refetch em qualquer query que use reloadKey
  reloadKey: number;
  reload: () => void;

  // Callback de busca registrado pela página ativa
  buscarHeader: (() => void) | null;
  registrarBuscar: (fn: (() => void) | null) => void;
}

export const SimplesNacionalContext = createContext<SimplesNacionalContextData | undefined>(
  undefined
);

export function useSimplesNacional(): SimplesNacionalContextData {
  const ctx = useContext(SimplesNacionalContext);
  if (!ctx) {
    throw new Error('useSimplesNacional deve ser usado dentro de SimplesNacionalProvider');
  }
  return ctx;
}
